import { useEffect } from "react";
import { useLocation } from "react-router";

/** Start each destination at its heading without disrupting in-page anchors. */
export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, [pathname]);

  return null;
}
